module.exports = __webpack_public_path__ + "img/curved25.2f17fc62.jpeg";